import React from 'react'
import Icon from 'antd/lib/icon'

const styles = {
    container: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        width: '100%',
        zIndex: 9999
    },
    icon: {
        fontSize: '48px',
        display: 'block',
        margin: '0 auto',
        position: 'relative',
        top: '50%',
        transform: 'translateY(-50%)',
    },
}

const Loading = () => (
    <div style={styles.container}>
        <Icon spin="true" type="loading-3-quarters" theme="outlined" style={styles.icon} />
    </div>
)

export default Loading
